import { render } from "./GateConfigComponent.vue?vue&type=template&id=eb6c15a6&ts=true"
import script from "./GateConfigComponent.ts?vue&type=script&lang=ts"
export * from "./GateConfigComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__